



































































import Vue from 'vue';
import Slider from '@common/slider/slider.vue';

type Intervals = '0' | '25' | '50' | '75' | '100';

export default Vue.extend({
  name: 'ItineraryPreferencesTiming',
  components: {Slider},
  props: {},
  data() {
    return {
      planActivity: [10, 14],
      breakfastWindow: [8, 11],
      lunchWindow: [12, 16],
      dinnerWindow: [18, 20],
      activity: '4-6h',
      timeBetweenActivities: 'Comfortable (15-30m)',
      sitting: '2-4h',
      walkingActivities: '4-6h',
      exerciseSports: 'None',
      intervalMarks: {
        0: {
          label: '<1h',
          labelStyle: {
            transform: 'translateX(0)',
          },
        },
        25: '2-4h',
        50: '4-6h',
        75: '6-8h',
        100: {
          label: 'Full Day',
          labelStyle: {
            transform: 'translateX(-32px)',
          },
        },
      },
      experciseSportsMarks: {
        0: {
          label: 'None',
          labelStyle: {
            transform: 'translateX(0)',
          },
        },
        20: '<1h',
        40: '2-4h',
        60: '4-6h',
        80: '6-8h',
        100: {
          label: 'Full Day',
          labelStyle: {
            transform: 'translateX(-32px)',
          },
        },
      },
      timeBetweenActivitiesMarks: {
        0: {
          label: 'Efficient (<15m)',
          labelStyle: {
            transform: 'translateX(0)',
          },
        },
        33: 'Comfortable (15-30m)',
        66: 'Leisurely (up to 1h)',
        100: {
          label: 'Any',
          labelStyle: {
            transform: 'translateX(-32px)',
          },
        },
      },
      mapper: {
        intervals: {
          '<1h': 0,
          '2-4h': 25,
          '4-6h': 50,
          '6-8h': 75,
          'Full Day': 100,
        },
        experciseSports: {
          None: 0,
          '<1h': 20,
          '2-4h': 40,
          '4-6h': 60,
          '6-8h': 80,
          'Full Day': 100,
        },
        timeBetweenActivities: {
          'Efficient (<15m)': 0,
          'Comfortable (15-30m)': 33,
          'Leisurely (up to 1h)': 66,
          Any: 100,
        },
      },
    };
  },
  methods: {
    handleSliderChange(value: number[]) {
      this.planActivity = value;
    },
    handleBreakfastWindowChange(value: number[]) {
      this.breakfastWindow = value;
    },
    handleLunchWindowChange(value: number[]) {
      this.lunchWindow = value;
    },
    handleDinnerWindowChange(value: number[]) {
      this.dinnerWindow = value;
    },
    handleSittingChange(value: Intervals) {
      // @ts-ignore
      this.sitting = this.intervalMarks[value].label || this.intervalMarks[value];
    },
    handleWalkingActivitiesChange(value: Intervals) {
      // @ts-ignore
      this.walkingActivities = this.intervalMarks[value].label || this.intervalMarks[value];
    },
    handleActivityChange(value: Intervals) {
      // @ts-ignore
      this.activity = this.intervalMarks[value].label || this.intervalMarks[value];
    },
    handleExerciseSportsChange(value: Intervals) {
      // @ts-ignore
      this.exerciseSports = this.experciseSportsMarks[value].label || this.experciseSportsMarks[value];
    },
    handleTimeBetweenActivitiesChange(value: string) {
      this.timeBetweenActivities =
        // @ts-ignore
        this.timeBetweenActivitiesMarks[value].label || this.timeBetweenActivitiesMarks[value];
    },
    formatTime(value: number): string {
      const AmOrPm = value >= 12 ? 'PM' : 'AM';
      const hours = Math.ceil(value % 12 || 12);
      const minutes = value % 1;
      const finalTime = `${hours}${minutes ? ':' + minutes * 60 : ''}${AmOrPm}`;
      return finalTime;
    },
  },
  computed: {
    planActivityTitle(): string {
      return `${this.formatTime(this.planActivity[0])} to ${this.formatTime(this.planActivity[1])}`;
    },
    breakfastWindowTitle(): string {
      return `${this.formatTime(this.breakfastWindow[0])}-${this.formatTime(this.breakfastWindow[1])}`;
    },
    lunchfastWindowTitle(): string {
      return `${this.formatTime(this.lunchWindow[0])}-${this.formatTime(this.lunchWindow[1])}`;
    },
    dinnerWindowTitle(): string {
      return `${this.formatTime(this.dinnerWindow[0])}-${this.formatTime(this.dinnerWindow[1])}`;
    },
    timeBetweenActivitiesTitle(): number {
      // @ts-ignore
      return this.mapper.timeBetweenActivities[this.timeBetweenActivities];
    },
    activityTitle(): number {
      // @ts-ignore
      return this.mapper.intervals[this.activity];
    },
    sittingTitle(): number {
      // @ts-ignore
      return this.mapper.intervals[this.sitting];
    },
    walkingActivitiesTitle(): number {
      // @ts-ignore
      return this.mapper.intervals[this.walkingActivities];
    },
    experciseSportsTitle(): number {
      // @ts-ignore
      return this.mapper.experciseSports[this.exerciseSports];
    },
  },
});
